/**
 * Classic hero-image + thumbnail gallery for the product template.
 * Pairs with snippets/product-media-gallery.liquid.
 *
 * Uses Slick (already loaded site-wide) with asNavFor to sync the main image
 * and thumbnail carousels and provide Previous/Next arrows on both. Variant
 * changes call slickGoTo internally, which repositions the carousel track
 * only - it never scrolls the page.
 *
 * Variant -> image sync piggybacks on the theme's existing 'cc-variant-updated'
 * jQuery event (fired in assets/theme.js from theme.OptionManager), so this file
 * does not touch or duplicate the variant-selection logic already in theme.js.
 */
(function () {
  function initGallery(root) {
    var $ = window.jQuery;
    if (!$ || !$.fn.slick || root.dataset.galleryInitialized) return;
    root.dataset.galleryInitialized = 'true';

    var $root = $(root);
    var $main = $root.find('.product-gallery__main');
    var $thumbs = $root.find('.product-gallery__thumbs');
    var hasThumbs = $thumbs.length > 0;
    var initialIndex = parseInt(root.getAttribute('data-initial-index'), 10) || 0;
    var enableZoom = root.getAttribute('data-enable-zoom') === 'true';

    $main.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      adaptiveHeight: true,
      infinite: false,
      initialSlide: initialIndex,
      asNavFor: hasThumbs ? $thumbs : undefined
    });

    if (hasThumbs) {
      // Always show exactly 4 thumbnails; the rest are reachable via the
      // Previous/Next arrows.
      $thumbs.slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        focusOnSelect: true,
        initialSlide: initialIndex,
        asNavFor: $main
      });
    }

    // Called from the cc-variant-updated listener below.
    root.ccGoToMedia = function (mediaId) {
      mediaId = String(mediaId);
      var $item = $main.find('.product-gallery__main-item[data-media-id="' + mediaId + '"]');
      if (!$item.length) return;

      var index = $main.find('.product-gallery__main-item').index($item.get(0));
      if (index > -1) {
        $main.slick('slickGoTo', index);
      }
    };

    if (enableZoom) {
      $main.on('click', '.product-gallery__image-wrapper', function () {
        // Matches the theme's existing zoom convention: desktop only.
        if (window.innerWidth < 768) return;
        openZoomModal($root, this.querySelector('img'));
      });
    }
  }

  function openZoomModal($root, clickedImg) {
    if (!clickedImg || typeof window.showThemeModal !== 'function') return;

    var jq = window.jQuery;
    var allImages = $root.find('.product-gallery__main-item img[data-full-size]').toArray();
    var thisSrc = clickedImg.currentSrc || clickedImg.src;
    var html = '<a href="#" data-modal-close class="modal-close">&times;</a>';

    allImages.forEach(function (img) {
      var smallSrc = img.currentSrc || img.src;
      var fullSrc = img.getAttribute('data-full-size');
      var extraAttrs = thisSrc === smallSrc ? "id='zoom-image'" : '';
      html += '<img class="zoom-image" ' + extraAttrs + ' src="' + smallSrc + '" data-full-size="' + fullSrc + '"/>';
    });

    window.showThemeModal(
      jq('<div class="theme-modal theme-modal--fullscreen temp -light" role="dialog" aria-modal="true"/>').append(
        "<div class='inner-scroller -out'>" + html + '</div>'
      ),
      'product-image',
      function ($modal) {
        var $mainImage = jq('#zoom-image');
        $mainImage.attr('src', $mainImage.data('full-size'));

        setTimeout(function () {
          $modal.find('[data-full-size]').each(function () {
            jq(this).attr('src', jq(this).data('full-size'));
          });
        }, 100);

        setTimeout(function () {
          $modal.scrollTop($mainImage.position().top + ($mainImage.outerHeight() / 2 - $modal.outerHeight() / 2));
          $modal.find('.inner-scroller').removeClass('-out');
        }, 1000);
      }
    );
  }

  function initAllGalleries() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-product-gallery]'), initGallery);
  }

  document.addEventListener('DOMContentLoaded', initAllGalleries);
  document.addEventListener('shopify:section:load', initAllGalleries);

  if (window.jQuery) {
    jQuery(window).on('cc-variant-updated', function (event, args) {
      if (!args || !args.variant || !args.variant.featured_media || !args.product) return;

      Array.prototype.forEach.call(document.querySelectorAll('[data-product-gallery]'), function (gallery) {
        if (String(gallery.getAttribute('data-product-id')) !== String(args.product.id)) return;
        if (typeof gallery.ccGoToMedia === 'function') {
          gallery.ccGoToMedia(args.variant.featured_media.id);
        }
      });
    });
  }
})();
